import { BaseMoveFileService } from "../service/base-move-file-service";
// @ts-ignore
import FolderSelector from '@tencent/docs-scenario-components-mobile-folder-selector';
import { Snackbar } from '@tencent/dui-mobile';
export var getMobileMoveFileService = function getMobileMoveFileService() {
  return new BaseMoveFileService(FolderSelector, Snackbar, false);
};